<template>
    <IndexTemplate
        :description="
            indexDescription ||
            $lang.get(
                'All published :models can be found here. Try using our filters for refined results within specific areas and subjects. You can also publish your own :models here by using the “Create” button.',
                {
                    models: $getBaseModelTranslation({
                        modelName: 'resource',
                        wordClass: 'PLURAL',
                    }),
                }
            )
        "
        modelClass="resource"
        :can="permissions"
    >
        <DataTable
            modelClass="resource"
            :gridCardTransformer="gridCardTransformer"
            :dataUrl="route('api.resource.data')"
            :highlight="highlight"
            :trending="trending"
            :filters="filters"
            :queryParams="queryParams"
            :showPersonalizedView="showPersonalizedView"
        />
    </IndexTemplate>
</template>

<script>
import IndexTemplate from '@/Templates/IndexTemplate.vue'
import DataTable from '@/Components/DataTable/DataTable.vue'

export default {
    components: {
        IndexTemplate,
        DataTable,
    },

    props: {
        highlight: {
            type: Object,
            default: null,
        },
        trending: {
            type: Array,
            default: () => [],
        },
        permissions: {
            type: Object,
            required: true,
        },
        filters: {
            type: Array,
            required: true,
        },
        queryParams: {
            type: Object,
            required: true,
        },
        indexDescription: {
            type: [String, null],
            required: true,
        },
        showPersonalizedView: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        gridCardTransformer(data) {
            if (data && data.length) {
                let resource
                return data.map((item) => {
                    resource = {
                        id: item.id,
                        name: item.name,
                        modelClass: 'resource',
                        url: item.url,
                        description: item.description,
                        short_description: item.short_description,
                        imageUrl: item.image ? item.image : null,
                        date: item.created_at,
                        type: item.type,
                        type_id: item.type_id,
                        file: item.file,
                        attributes: item.attributes,
                        can: item.can,
                        is_draft: item.is_draft,
                        is_featured: item.is_featured,
                    }

                    if (item.resourceable_link && item.resourceable_name) {
                        resource.subtitleLink = {
                            url: item.resourceable_link,
                            text: item.resourceable_name,
                        }
                    }

                    return resource
                })
            }
            return []
        },
    },
}
</script>
